import { type Dispatch, type SetStateAction } from 'react'
import { format } from 'date-fns/format'
import { parse } from 'date-fns/parse'
import type { DateRange } from '@pcln/horizon'
import type { UseFormSetValue } from 'react-hook-form'
import type { PackagesFormStateType } from '../types'

export function handleSingleDateCalendarChange(
  setValue: UseFormSetValue<PackagesFormStateType>,
  watchLabel: keyof PackagesFormStateType,
  setDefaultMonth: Dispatch<SetStateAction<Date>>,
  date: Date
) {
  const formattedDate = format(date, 'yyyyMMdd')
  setValue(watchLabel, formattedDate)
  setDefaultMonth(date)
}

export function handleDateRangeCalendarChange(
  setValue: UseFormSetValue<PackagesFormStateType>,
  watchStartLabel: keyof PackagesFormStateType,
  watchEndLabel: keyof PackagesFormStateType,
  setDefaultMonth: Dispatch<SetStateAction<Date | undefined>>,
  dates?: DateRange
) {
  if (dates?.from) {
    const startDate = format(dates.from, 'yyyyMMdd')
    setValue(watchStartLabel, startDate)
    setDefaultMonth(dates.from)
  }
  if (dates?.to) {
    const endDate = format(dates.to, 'yyyyMMdd')
    setValue(watchEndLabel, endDate)
  }
}

export const isString = (value: unknown): value is string => {
  return typeof value === 'string'
}

export function getPartStaySelectedDates(
  watchHotelStartDate?: string,
  watchHotelEndDate?: string,
  watchStartDate?: string,
  watchEndDate?: string
) {
  if (watchHotelStartDate) {
    return {
      from: parse(watchHotelStartDate, 'yyyyMMdd', new Date()),
      to: watchHotelEndDate
        ? parse(watchHotelEndDate, 'yyyyMMdd', new Date())
        : undefined
    }
  }
  return {
    from: watchStartDate
      ? parse(watchStartDate, 'yyyyMMdd', new Date())
      : undefined,
    to: watchEndDate ? parse(watchEndDate, 'yyyyMMdd', new Date()) : undefined
  }
}
